// extracted by mini-css-extract-plugin
export var box = "_25-1";
export var checkboxRow = "_25-8";
export var checked = "_25-2";
export var descriptionSpacer = "_25-a";
export var disabled = "_25-3";
export var icon = "_25-6";
export var input = "_25-0";
export var labelSpacer = "_25-9";
export var medium = "_25-5";
export var small = "_25-4";
export var text = "_25-7";